import { useQuery } from '@tanstack/react-query';
import { standardRequest } from 'shared/utils/request';
import { SendEmailModalOptionsResponse } from 'talent_matching/types';
import type { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown/item';

type BulkEmailModalOptionsResponse = SendEmailModalOptionsResponse & {
  fromOptions: Array<Item & { domain: string; domain_unverified: boolean }>;
  displayDomainWarning: boolean;
};

export const useSendEmailData = (emailModalPath: string) => {
  return useQuery<BulkEmailModalOptionsResponse, Error>({
    queryKey: ['sendEmailModalData', emailModalPath],
    queryFn: async () => {
      const response = await standardRequest.get(emailModalPath);
      return response.data;
    },
    staleTime: 1000 * 60 * 10, // 10 minutes
  });
};
